var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"qa",rawName:"v-qa",value:('navigation'),expression:"'navigation'"}]},_vm._l((_vm.links),function(ref){
var path = ref.path;
var text = ref.text;
return _c('nuxt-link',{directives:[{name:"qa",rawName:"v-qa",value:(("nav_link_" + path)),expression:"`nav_link_${path}`"}],key:path,staticClass:"link",attrs:{"to":_vm.localePath(path)}},[_vm._v("\n    "+_vm._s(text)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }